module.exports = __webpack_public_path__ + "img/logo.56bd05fd.svg";